// import Papa from "papaparse";

const Csv = {

    csvLineSplitByColumn(csvLine: string, separator: string): Array<string> {
        let result: Array<string> = [];
        let last_column = "";
        let in_text = false;
        for (let iC = 0; iC < csvLine.length; iC++) {
            let currentChar = csvLine[iC];
            if (in_text) {
                if (currentChar == "\"") {
                    last_column += currentChar;
                    in_text = false;
                }
                else {
                    last_column += currentChar;
                }
            }
            else {
                if (currentChar == separator) {
                    result.push(last_column);
                    last_column = "";
                } else if (currentChar == "\"") {
                    in_text = true;
                    last_column += currentChar;
                } else if (currentChar == "\n") {
                } else {
                    last_column += currentChar;
                }
            }
        }
        return result;
    },

    detectCsvSeparator(csvText: string): string {
        const separators = [",", ";", "\t", "|"];
        const separatorsCount = new Map();

        for (let i = 0; i < csvText.length; i++) {
            let c = csvText[i] as string; // ✅ poprawka

            if (separators.includes(c)) {
                let count = separatorsCount.has(c) ? separatorsCount.get(c) : 0;
                separatorsCount.set(c, count + 1);
            }
        }

        // znajdź separator z największą liczbą wystąpień
        let bestSeparator = ",";
        let maxCount = 0;

        for (let [sep, count] of separatorsCount.entries()) {
            if (count > maxCount) {
                maxCount = count;
                bestSeparator = sep;
            }
        }

        return bestSeparator;
    },

    parseCSV(csvText: string): Array<Array<string>> {
        // const result = Papa.parse<string[]>(csvText, { skipEmptyLines: true })
        // return result.data;
        let column_separator = Csv.detectCsvSeparator(csvText);
        let rows = csvText
            .split("\n")
            .map((line) => line.trim())
            .filter((line) => line.length > 0)
            .map((line) => Csv.csvLineSplitByColumn(line, column_separator));

        return rows;
    },

    convertToObjectsFirstRowAsHeader(data: Array<Array<string>>): Array<{ [key: string]: string }> {
        if (data.length <= 1) {
            return [];
        }
        let headerRow: Array<string> = data[0] as Array<string>;
        const getColumnName = (columnIndex: number): string => {
            let columnName = headerRow[columnIndex];
            return columnName == undefined ? 'Column-' + columnIndex : columnName;
        };
        let bodyRows = data.slice(1);

        return bodyRows.map(row => {
            let obj: { [key: string]: string } = {};
            row.forEach((rowColumnValue: string, columnIndex: number) => {
                obj[getColumnName(columnIndex)] = rowColumnValue;
            })
            return obj;
        });
    }
}

export default Csv;